// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3IUrv","name":"ConsentHeader_name__3K1eB","birthday":"ConsentHeader_birthday__2oFXU","skeleton":"ConsentHeader_skeleton__3iq-M"};